<template>
<v-layout row wrap justify-left align-top>
    <v-flex xs6 sm3 md2 my-3 v-for="id in scopes" :key="id"> 
      <ManipulativeItem :id="id" />
    </v-flex>
</v-layout>
</template>

<script>
import {find} from 'lodash'
import manips from '@/data/manips.js'
import ManipulativeItem from '@/components/ManipulativeListItem'

export default {
  props: {
    scope: {
      type: String,
      required: true
    }
  },
  components: {
    ManipulativeItem
  },
  data: function () {
    return {
      scopes: []
    }
  },
  mounted: function () {
    if (this.scope === '*') {
      this.scopes = manips.map(manip => {
        return manip.id
      })
    } else {
      const manip = find(manips, {'id': this.scope});

      this.scopes =[manip.id]
    }
  }
}
</script>

<style scoped>
</style>
